import React from 'react'
import { connect } from 'react-redux'
import { mapDispatchToProps } from '../../../helpers/redux.helper'
import SimpleBtn from '../../SimpleBtn'
import { translate } from 'react-i18next'
import './index.sass'

const ServiceDetailTitle = ({
  title,
  type = 'services',
  t,
  actions: { changeModalVisibility, toggleVisibleAudioPlayer, setPlayingStatus, setChoosenVoice },
  serviceDetail,
}) => {
  const className = serviceDetail.split(' ').join('-')
  return (
    <div className={`service-detail-title ${className}`}>
      <div className="service-detail-wrapper">
        <h2 className={`${title}`}>{type === 'services'?t(`services.${title}`): 'Fiverr voice over'}</h2>
        <h1>{type === 'services'? t(`services.${serviceDetail}`) : 'BLOG'}</h1>
        <div className="service-detail-btn-wrapper">
          <SimpleBtn
            border
            btnName={t('general.order voice')}
            onHandleClick={() => {
              changeModalVisibility(true)
              setPlayingStatus(false)
              toggleVisibleAudioPlayer(false)
              setChoosenVoice(serviceDetail)
            }}
          />
        </div>
        <div className="border border-left" />
        <div className="border border-right" />
      </div>
    </div>
  )
}

export default translate('translations')(
  connect(
    null,
    mapDispatchToProps
  )(ServiceDetailTitle)
)
